import { MessageService } from 'primeng/primeng';
import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { Observable } from 'rxjs/Observable';
import { Reason } from '../../models/loyalty-reason.model';
import { URLSearchParams } from '@angular/http';
import { ListMetadata } from '../../models/list-metadata.model';
import { publishReplay, refCount } from 'rxjs/operators';

@Injectable()
export class LoyaltyReasonService {

  private cache = new Map<string, Reason>();
  public baseUrl = '/koncentro-loyalty';
  private cachedFields: Observable<any>;

  constructor(
    private http: HttpClientService,
    private srvNotify: MessageService
  ) { }

  get(reasonId): Observable<Reason> {

    if (this.cache.has(reasonId)) {
      return Observable.of(this.cache.get(reasonId));
    }

    return this.http.get(this.baseUrl + '/reason/' + reasonId).map(res => {
      // this.cache.set(res.id);
      return res;
    });
  }

  listPointReason(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<Reason>, metadata: ListMetadata }> {
    let params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    
    // Aggiunta dei nuovi parametri alla query string
    const additionalParams = 'paramKey=POINTREASON.TYPE&flg_state=0';
    const queryString = params.toString() ? `${params.toString()}&${additionalParams}` : additionalParams;
    
    return this.http.getPaged(this.baseUrl + '/reason/getReasonList?' + queryString);
  }
  


  list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<Reason>, metadata: ListMetadata }> {
    let params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.getPaged(this.baseUrl + '/reason/getReasonList?' + params.toString());
  }




  
  getList (
      offset = null,
      limit = null,
      search?: Array<{ key: string, value: string }>,
      globalSearch?: string,
      sort?: string,
      sort_dir?: number
  ): Observable <{data: Array<Reason>, metadata: ListMetadata}> {
    let params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.get(this.baseUrl + '/reason/getReasonList?' + params.toString());
}

  update(reason: Reason): Observable<Reason> {
    return this.http.put(this.baseUrl + '/reason/' + reason.id, reason).map(res => {
      this.cache.delete(reason.id);
      return res;
    });
  }

  create(reason: Reason): Observable<Reason> {
    return this.http.post(this.baseUrl + '/reason/' , reason );
  }

  remove(reasonId): Observable<Reason> {
    return this.http.delete(this.baseUrl + '/reason/' + reasonId).map(res => {
      this.cache.delete(reasonId);
      this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      return res;
    });
  }
  recover(reason) {    
    return this.http.put(this.baseUrl + "/reason/recover/" + reason.id, reason)
      .map(res => {
        this.cache.delete(reason.id);
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.http.get(`${this.baseUrl}/schema/ReasonDto`).pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/reason.service.ts